import React from 'react';
import { useTranslation } from 'react-i18next';
import Section from '../components/common/Section';

const Resources = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      <Section 
        title={t('resources.title')} 
        subtitle={t('resources.subtitle')}
      >
        <p>{t('resources.content')}</p>
      </Section>
    </div>
  );
};

export default Resources;